export const currentuser = () => {
    let user: any = localStorage.getItem("user");
    let user_id = user ? JSON.parse(user) : null;
    return user_id
}